import { CopyToClipboardButton } from '@plerionhq/design-system';

type AccessGrantDetailRowProperties = {
  label: string;
  value: React.ReactNode;
  copyValue?: string;
};

export function AccessGrantDetailRow({
  label,
  value,
  copyValue,
}: AccessGrantDetailRowProperties) {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  return (
    <div className="flex flex-col items-start gap-1 py-2">
      <dt className="text-xs font-normal text-gray-600 dark:text-gray-400">
        {label}
      </dt>
      <dd className="flex w-full flex-row items-start gap-1 text-sm font-medium break-all text-gray-700 dark:text-gray-300">
        {copyValue && (
          <CopyToClipboardButton
            text={copyValue}
            className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-500 dark:text-gray-400"
          />
        )}
        <div className="min-w-0 flex-1">{value}</div>
      </dd>
    </div>
  );
}

const SECTION_LIST_CLASSNAMES: Record<1 | 2, string> = {
  1: 'divide-y divide-gray-100 dark:divide-gray-700',
  2: 'grid grid-cols-2 gap-x-8',
};

type AccessGrantDetailSectionProperties = {
  title: string;
  children: React.ReactNode;
  columns?: 1 | 2;
};

export function AccessGrantDetailSection({
  title,
  children,
  columns = 1,
}: AccessGrantDetailSectionProperties) {
  return (
    <section className="mb-5 last:mb-0">
      <h4 className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
        {title}
      </h4>
      <dl className={SECTION_LIST_CLASSNAMES[columns]}>{children}</dl>
    </section>
  );
}
